import { Component, inject } from '@angular/core';
import { ListService } from '@abp/ng.core';
import { ConfirmationService } from '@abp/ng.theme.shared';
import {
  BaseHierarchicalCrudComponent,
  GenericForm,
  IActionsSchema,
  ICrudService,
  FieldMapperHelper,
  ZnHierarchicalViewComponent,
} from '@zendra/shared';
import { CommonModule } from '@angular/common';
import {
  OtherUseCreateDto,
  OtherUseDto,
  OtherUseExcelDownloadDto,
  OtherUseUpdateDto,
} from 'projects/cbd-proxies/src/lib/proxy/dtos/other-use';
import { OtherUseService } from 'projects/cbd-proxies/src/lib/proxy/controllers/other-use.service';
import { OTHERUSE_CONFIG, OTHERUSE_FIELDS } from './other-use.config';
import { OtherUseOrchestratorService } from 'projects/cbd-proxies/src/lib/orchestrator/orchestrator/app-services/other-use-orchestrator.service';
import { OtherUseCreateWithLocationDto } from 'projects/cbd-proxies/src/lib/orchestrator/orchestrator/dtos/other-use/models';

@Component({
  selector: 'app-other-use',
  imports: [CommonModule, GenericForm, ZnHierarchicalViewComponent],
  providers: [ListService, OtherUseService, ConfirmationService],
  templateUrl: './other-use.html'
})
export class OtherUse extends BaseHierarchicalCrudComponent<
  OtherUseDto,
  OtherUseCreateDto | OtherUseCreateWithLocationDto,
  OtherUseUpdateDto,
  OtherUseExcelDownloadDto
> {
  private readonly crudService = inject(OtherUseService);
  private readonly orchestratorService = inject(OtherUseOrchestratorService);
  service: ICrudService<OtherUseDto, OtherUseCreateDto | OtherUseCreateWithLocationDto, OtherUseUpdateDto, OtherUseExcelDownloadDto> = {
    create: input => 'locationId' in input
      ? this.crudService.create(input)
      : this.orchestratorService.createWithLocation(input, { apiName: 'Planning' }),
    update: (id, input) => this.crudService.update(id, input),
    deleteByIds: ids => this.crudService.deleteByIds(ids),
    getList: query => this.crudService.getList(query),
    getListByIds: input => this.crudService.getListByIds(input),
    getDownloadToken: () => this.crudService.getDownloadToken(),
    getListAsExcelFile: input => this.crudService.getListAsExcelFile(input),
  };
  config = OTHERUSE_CONFIG;
  fields = OTHERUSE_FIELDS;
  actions: IActionsSchema | null = null;

  override create(): void {
    if (this.parentId !== undefined && this.parentFilterField === 'locationId') {
      super.create();
      return;
    }

    this.selectedEntity = {} as OtherUseDto;
    const fields = FieldMapperHelper.mapFieldsForForm(
      this.fields.filter(field => field.key !== 'locationId'),
      this.selectedEntity,
      this.injector,
    );
    this.genericForm.open({
      title: `${this.localizationResource.LanguageService}::TableNewRegistry`,
      fields,
      entityLocaleKey: this.config.localizationKey,
      mode: 'create',
    });
  }

  protected prepareUpdateDto(data: any, selected: OtherUseDto): OtherUseUpdateDto {
    return {
      name: data.name,
      otherUsearea: data.otherUsearea,
      soilUseId: data.soilUseId,
      locationId: data.locationId,
      propertyId: data.propertyId,
      propertyTypeId: data.propertyTypeId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'OtherUse';
  }
}
